// extracted by mini-css-extract-plugin
export default {"card":"Styles_card__GZ6FH","mainContainer":"Styles_mainContainer__IHu4l","header":"Styles_header__mqsqK","headerContainer":"Styles_headerContainer__2xYJr"};